export default {
    confirmed: "Your account could not be verified",
    account: "Please wait while we confirm your account",
    invalid: "The code in the link is invalid.",
    settings: "Back to Settings",
    zhifou_account: "Zhifou Accounts",
};
